import { render, staticRenderFns } from "./RegisterManagement.vue?vue&type=template&id=d8d47bdc&scoped=true"
import script from "./RegisterManagement.vue?vue&type=script&lang=js"
export * from "./RegisterManagement.vue?vue&type=script&lang=js"
import style0 from "./RegisterManagement.vue?vue&type=style&index=0&id=d8d47bdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8d47bdc",
  null
  
)

export default component.exports